document.addEventListener('DOMContentLoaded', () => {
  const forms = document.querySelectorAll('.bundle-form-modern');
  forms.forEach(form => {
    const selects = form.querySelectorAll('.variant-select-modern');
    const addButton = form.querySelector('.add-to-cart-modern');
    const discountCode = form.getAttribute('data-discount');

    addButton.addEventListener('click', async () => {
      const itemsToAdd = [];
      selects.forEach(select => {
        if (select.value) {
          itemsToAdd.push({ id: parseInt(select.value), quantity: 1 });
        }
      });
      if (itemsToAdd.length !== selects.length) {
        alert('Por favor selecciona variantes para todos los productos.');
        return;
      }
      try {
        await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items: itemsToAdd })
        });
        // Redirect to checkout with the bundle's discount code
        if (discountCode) {
          window.location.href = `/checkout?discount=${discountCode}`;
        } else {
          window.location.href = '/cart';
        }
      } catch (error) {
        alert('Hubo un error al agregar los productos al carrito. Intenta de nuevo.');
      }
    });
  });
});
